import {
    CommonRoutes,
    FilterType,
} from 'app/enums/common.enums'
import {
    CollectionServiceType,
    ContractCurrency,
    DeliveryServiceType,
    LaneFeesStatus,
    ProductType,
} from 'app/enums/label.enums'
import {
    injectFieldsToTabs,
    SkyNetTableConfig,
    SkyNetTableField,
} from 'app/shared-components/SkyNetTable'
import {
    LaneFeesFilterRequestResponse,
} from 'app/Apps/Pricing/LaneFees/LaneFees.types'

const fields: SkyNetTableField<keyof LaneFeesFilterRequestResponse>[] = [
    {
        name: 'laneFeesNumber',
        labelKey: 'LaneFeesView.lfNumber',
        width: '130px',
        reduced: true,
    },
    {
        name: 'laneFeesStatus',
        labelKey: 'LaneOpsInformationDto.laneStatus',
        filterField: 'laneFeesStatus',
        filterType: FilterType.Array,
        componentName: 'EnumValue',
        allowedValuesEnum: LaneFeesStatus,
        width: '130px',
        reduced: true,
    },
    {
        name: 'laneGroupNumber',
        labelKey: 'LaneGroupBasicView.laneGroupNumber',
        width: '130px',
        reduced: true,
    },
    {
        name: 'contractBasisNumber',
        labelKey: 'LaneFeesView.cbNumber',
        width: '130px',
    },
    {
        name: 'pricingAccountCompanyName',
        labelKey: 'AccountLane.pricingAccount',
        filterField: 'pricingAccountCompanyName',
        filterType: FilterType.Array,
        width: '300px',
    },
    {
        name: 'customerQuotationLocationName',
        labelKey: 'ContractBasisFlat.customerQuotationLocationName',
        filterField: 'customerQuotationLocationName',
        filterType: FilterType.Array,
        width: '400px',
    },
    {
        name: 'contractBasisCurrency',
        labelKey: 'LaneOpsInformationDto.currency',
        filterField: 'contractBasisCurrency',
        filterType: FilterType.Array,
        allowedValuesEnum: ContractCurrency,
        width: '130px',
    },
    {
        name: 'originAirportsIataCode',
        componentName: 'List',
        labelKey: 'AccountLane.originAirport',
        filterField: 'originAirportsIataCode',
        filterType: FilterType.Array,
        width: '200px',
    },
    {
        name: 'destinationAirportsIataCode',
        componentName: 'List',
        labelKey: 'AccountLane.destinationAirport',
        filterField: 'destinationAirportsIataCode',
        filterType: FilterType.Array,
        width: '200px',
    },
    {
        name: 'validFrom',
        labelKey: 'LaneFees.validFrom',
        filterField: 'validFrom',
        filterType: FilterType.DateRange,
        componentName: 'DateTimeCell',
        width: '200px',
    },
    {
        name: 'validTo',
        labelKey: 'LaneFees.validTo',
        filterField: 'validTo',
        filterType: FilterType.DateRange,
        componentName: 'LaneDateEnriched',
        width: '200px',
    },
    {
        name: 'allBaseLeaseProductType',
        labelKey: 'AccountQuotes.productTypes',
        allowedValuesEnum: ProductType,
        componentName: 'EnumList',
        width: '300px',
        sorting: false,
    },
    {
        name: 'rentalDays',
        labelKey: 'LaneFees.rentalDays',
        width: '130px',
    },
    {
        name: 'logisticsDays',
        labelKey: 'LaneFees.logisticsDays',
        width: '130px',
    },
    {
        name: 'laneGroupDeliveryServiceType',
        labelKey: 'LaneGroup.deliveryServiceType',
        filterField: 'laneGroupDeliveryServiceType',
        filterType: FilterType.Array,
        componentName: 'EnumValue',
        allowedValuesEnum: DeliveryServiceType,
        width: '200px',
    },
    {
        name: 'laneGroupHandoverPointLocationName',
        labelKey: 'LaneGroup.handoverPoint',
        filterField: 'laneGroupHandoverPointLocationName',
        filterType: FilterType.Array,
        width: '400px',
    },
    {
        name: 'laneGroupCollectionServiceType',
        labelKey: 'LaneGroup.collectionServiceType',
        filterField: 'laneGroupCollectionServiceType',
        filterType: FilterType.Array,
        componentName: 'EnumValue',
        allowedValuesEnum: CollectionServiceType,
        width: '200px',
    },
    {
        name: 'laneGroupCollectionDropoffPointLocationName',
        labelKey: 'Order.collectionDropoffPoint',
        filterField: 'laneGroupCollectionDropoffPointLocationName',
        filterType: FilterType.Array,
        width: '400px',
    },
]
const config: SkyNetTableConfig<keyof LaneFeesFilterRequestResponse> = {
    name: 'LaneFees',
    tabs: injectFieldsToTabs<keyof LaneFeesFilterRequestResponse>([{
        name: 'All',
        url: CommonRoutes.All,
    }], fields),
}

export default config
